import { errorHandler } from 'client/helpers/errorHandler';
import { IThunkAction } from 'types/IThunkAction';
import { startLoading, stopLoading } from 'client/_redux/actions/loading';
import * as invoiceServices from 'dashboard/_redux/services/invoices';
import { InvoicesDashboardTypes } from 'dashboard/_redux/types/invoicesDashboardTypes';
import { SearchQuery } from '../users';
import { toast } from 'react-toastify';

export const getUsersWithInvoices = (searchQuery: SearchQuery<unknown>): IThunkAction => async (
  dispatch,
) => {
  dispatch(startLoading());
  dispatch({ type: InvoicesDashboardTypes.FETCH_USERS_WITH_INVOICES_START });
  try {
    const data = await invoiceServices.getUsersWithInvoices()(searchQuery);

    dispatch({ type: InvoicesDashboardTypes.FETCH_USERS_WITH_INVOICES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: InvoicesDashboardTypes.FETCH_USERS_WITH_INVOICES_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const getUserInvoices = (userId: string): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  dispatch({ type: InvoicesDashboardTypes.FETCH_USER_INVOICES_START });
  try {
    const data = await invoiceServices.getUserInvoices()(userId);

    dispatch({ type: InvoicesDashboardTypes.FETCH_USER_INVOICES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: InvoicesDashboardTypes.FETCH_USER_INVOICES_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const sendInvoiceEmail = (invoiceId: string): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  try {
    await invoiceServices.sendInvoiceByEmail()(invoiceId);
    toast('Facture envoyée avec succès', { type: 'success' });
  } catch (error) {
    toast('Erreur lors de l\'envoi de la facture', { type: 'error' });
    errorHandler(error);
  }
  dispatch(stopLoading());
};
